module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/common/common.component.scss
// module id = ./src/app/seller/sub-component/common/common.component.scss
// module chunks = main